// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610011934/js/" + chunkId + "." + {"44":"e100da9c","225":"ed466085","481":"3fe19c62","486":"fcf26220","770":"e84da5d5"}[chunkId] + ".0.46801786199323003.chunk.js";
};